module.exports = __webpack_public_path__ + "img/user-info.1216cbac.jpg";